export const FileUploadRules = (props) => {
  return (
    <>
      <div className="_margin-top--2rem">
        <p className="_margin-bottom--1rem">Requirements</p>

        <ul className="_list-style-type--disc _margin-left--1rem">
          {props.allowedFileTypes.length === 0 && (
            <li>File type must be: props.allowedFileTypes[0]</li>
          )}
          <li>
            Allowed file types
            {props.allowedFileTypes.length > 0 && (
              <ul className="_padding-left--1rem _list-style-type--circle _list-style-position--inside">
                {props.allowedFileTypes.map((value, index) => {
                  return (
                    <li key={index}>
                      <b>{value}</b>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
          <li>
            File size must be less than <b>{props.fileSizeLimitMBs}MB</b>
          </li>
        </ul>
      </div>
    </>
  );
};
